import { GiHamburgerMenu } from "react-icons/gi";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import styled, { CSSProperties } from "styled-components";
import { Link } from "react-router-dom";

import { getScreenWidth } from "../../../constants";

const IconStyle = styled.button`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  padding: 10px;
  border: none;
  background-color: transparent;

  &:hover {
    border: 0px solid #ddd;
    border-radius: 25px;
    background-color: #f2efe7;
  }
`;

const titleStyle: CSSProperties = {
  fontSize: "1.8rem",
  fontWeight: "bold",
  marginRight: "100px",
  display: "flex",
  alignItems: "center",
  gap: "10px",
};

const appIconStyle: CSSProperties = {
  height: "2.7rem",
  width: "auto",
};

const linkTextStyle = {
  textDecoration: "underline",
  color: "#5271FF",
};

const Header = ({ onMenuClick }: { onMenuClick: () => void }) => {
  const { isTwoColumn } = getScreenWidth();

  return (
    <Navbar>
      <IconStyle className="mx-2" onClick={onMenuClick}>
        <GiHamburgerMenu />
      </IconStyle>
      <Navbar.Brand href="#home" style={titleStyle}>
        <img src={`${process.env.PUBLIC_URL}/icon.png`} alt="" style={appIconStyle} />
        キントレマニア
      </Navbar.Brand>
      {isTwoColumn && (
        <Nav className="me-auto">
          <Nav.Item>
            <Link to="/lp" className="nav-link" style={linkTextStyle}>
              本サービスについて
            </Link>
          </Nav.Item>
          <Nav.Item>
            <Link to="/contact" className="nav-link" style={linkTextStyle}>
              お問い合わせ
            </Link>
          </Nav.Item>
        </Nav>
      )}
    </Navbar>
  );
};

export default Header;
